import Image from "@/components/AppImage";
import GetStarted from "./GetStarted";
import feature_icon_1 from "/public/img/feature-icon-1.png";
import feature_icon_2 from "/public/img/feature-icon-2.png";
import feature_icon_3 from "/public/img/feature-icon-3.png";

const Banner = () => {
  return (
    <section className="banner-section index-2">
      <div className="overlay">
        <div className="banner-content d-flex align-items-center">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-10 col-md-10">
                <div className="item-bottom">
                  <div className="main-content">
                    <div className="top-area justify-content-center">
                      <h1 className="text-center">
                        Global payouts built for freelancers
                      </h1>
                      <ul>
                        <li>
                          <Image src={feature_icon_1} alt="Icon" />
                          Get paid in local currency across 100+ countries
                        </li>
                        <li>
                          <Image src={feature_icon_2} alt="Icon" />
                          Transparent FX—see fees before you send an invoice
                        </li>
                        <li>
                          <Image src={feature_icon_3} alt="Icon" />
                          Dedicated support wherever your clients are
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Get Started */}
      <GetStarted />
    </section>
  );
};

export default Banner;
